import { render, staticRenderFns } from "./KnowledgeCenterListAdmin.vue?vue&type=template&id=36ea8caa&scoped=true"
import script from "./KnowledgeCenterListAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeCenterListAdmin.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/all_messages.css?vue&type=style&index=0&id=36ea8caa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea8caa",
  null
  
)

export default component.exports